import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';

import './styles.scss';

import audioNo from 'assets/sounds/no/2 1 ordkjedetekst.mp3';
import audioNn from 'assets/sounds/nn/2 1 ordkjedetekst.m4a';

const audioObj = {
	no: audioNo,
	nn: audioNn,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.audio = audioObj[strings.getLanguage()];
			this.ordkjedetestInstructions = this.props.isDldTest
			? strings.ordkjedetestInstructionsNorming
			: strings.ordkjedetestInstructions;
	}
	render() {
		const {onNextStep} = this.props;

		return (
			<div className="lit-intro">
				<p>
					<AudioPlayer autoplay
					 inline 
					 onErrorPlay={()=>{
						console.log('Something went wrong');
					}}
					 src={this.audio} />
					{this.ordkjedetestInstructions}
				</p>
				<button
					className="lit-btn bg-primary"
					onClick={() => {
								onNextStep();
								this.props.onShowAvatar(false);
							}}
				>
					{strings.showExamples}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
